<template>
    <div class="w-full">
        <div class="h-[32px] border-b-2 flex justify-between items-center  border-gray-300 w-full sticky top-0 bg-gray-200 pl-6 pr-2">
            <div class="w-32 h-4 rounded animate-pulse bg-gray-200"></div>
        </div>
            <div class='w-full px-6 py-3 h-[calc(100%-5rem)] overflow-y-auto'>
            <div class="flex flex-col">
                <div class="flex space-x-2 items-center justify-start h-9">
                    <label class="w-20 text-sm text-gray-600 tracking-wide">From:</label>
                    <div class="border-b flex items-center border-gray-300 bg-gray-200 rounded-t outline-none h-9 w-full animate-pulse">
        
                    </div>
                </div>
                <div class="flex space-x-2 items-center justify-start h-9">
                    <label class="w-20 text-sm text-gray-600 tracking-wide">To:</label>
                    <div class="border-b flex items-center border-gray-300 bg-gray-200 outline-none h-9 w-full animate-pulse">
        
                    </div>
                </div>
                <div class="flex space-x-2 items-center justify-start h-9">
                    <label class="w-20 text-sm text-gray-600 tracking-wide">Bcc:</label>
                    <div class="border-b flex items-center border-gray-300 bg-gray-200 outline-none h-9 w-full animate-pulse">
        
                    </div>
                </div>
                <div class="flex space-x-2 items-center justify-start h-9">
                    <label class="w-20 text-sm text-gray-600 tracking-wide">Subject:</label>
                    <div class="border-b flex items-center border-gray-300 bg-gray-200 rounded-b outline-none h-9 w-full animate-pulse">
        
                    </div>
                </div>
            </div>
            <div class="w-full pt-4 h-[calc(100%-13rem)]">
                <div class="flex flex-row h-full">
                    <div class="w-full h-full">
                        <div ref="emailBodyContainer" class=" w-full h-full min-h-[440px] rounded-md  border border-gray-300 bg-gray-200 p-4 overflow-auto animate-pulse">
                            <div :class="htmlBodyClass"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script setup>
import { computed, useTemplateRef } from 'vue';
import { useElementSize } from '@vueuse/core';

const emailBodyContainer = useTemplateRef('emailBodyContainer');
const { width, height } = useElementSize(emailBodyContainer)

const htmlBodyClass = computed(() => {
    return `w-[calc(${Math.floor(width)-32}px)] max-w-[(${Math.floor(width)-32}px)]`
})
</script>